import React from "react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { CONSENT_KEYS } from "../contract";
import { STATE_CLASSES } from "../theme/states";

const TONES = {
  consented: STATE_CLASSES.positive,
  not_consented: STATE_CLASSES.neutral,
  unsubscribed: STATE_CLASSES.danger,
};

/** Marketing consent: Consented / Not consented / Unsubscribed. */
export default function ConsentBadge({ status, className, testId }) {
  const t = useT("crm");
  if (!CONSENT_KEYS[status]) return null;
  return (
    <span data-testid={testId} data-consent={status}
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap", TONES[status], className)}>
      {t(CONSENT_KEYS[status])}
    </span>
  );
}
